exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".loading-state[data-v-4798daf3]{display:flex;justify-content:center;align-items:center;min-height:100vh;font-family:Arial,sans-serif;color:#666}", ""]);

